import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CaseStudyDetail from '../../../components/public/case-studies/CaseStudyDetail';
import Layout from '../../../components/public/common/Layout';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import { caseStudyService } from '../../../services/caseStudyService';

const CaseStudyDetailPage = () => {
  const { urlSlug } = useParams();
  const [caseStudy, setCaseStudy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCaseStudy = async () => {
      try {
        setLoading(true);
        // Check if urlSlug is a valid MongoDB ObjectId
        const isObjectId = /^[0-9a-fA-F]{24}$/.test(urlSlug);
        const data = isObjectId 
          ? await caseStudyService.getCaseStudyById(urlSlug)
          : await caseStudyService.getCaseStudyBySlug(urlSlug);  
        
        if (!data) {
          setError('Case study not found');
          return;
        }
        
        setCaseStudy(data);
      } catch (error) {
        console.error('Error fetching case study:', error);
        setError('Failed to fetch case study');
      } finally {
        setLoading(false);
      }
    };

    if (urlSlug) {
      fetchCaseStudy();
    }
  }, [urlSlug]);

  if (loading) {
    return (
      <Layout>
        <div className="flex justify-center items-center h-screen">
          <LoadingSpinner />
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="container mx-auto px-6 py-8">
          <div className="text-center text-red-600">{error}</div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <CaseStudyDetail caseStudy={caseStudy} />
    </Layout>
  );
};

export default CaseStudyDetailPage; 